import React, { type FC } from 'react'

import Icon from '@components/Icon'

interface SocialMediaLinkProps {
  url?: string
  iconName?: string
  label?: string
}

export interface SocialMediaLinks {
  [key: string]: string
}

interface SocialMediaBarProps {
  socialMediaLinks: SocialMediaLinks
  className?: string
}

const SocialMediaLink: FC<SocialMediaLinkProps> = ({
  url = '',
  iconName = '',
  label = '',
}) => (
  <a
    href={url}
    aria-label={label}
    className="inline-flex items-center justify-center mx-2"
    target="_blank"
  >
    <Icon name={iconName} size="auto" />
  </a>
)

const SocialMediaBar: FC<SocialMediaBarProps> = ({
  socialMediaLinks,
  className,
}) => (
  <div className={`flex items-center justify-center ${className}`}>
    {socialMediaLinks &&
      Object.entries(socialMediaLinks).map(([key, url]) => (
        <SocialMediaLink
          key={key}
          url={url}
          iconName={key.toLowerCase()}
          label={key.charAt(0).toUpperCase() + key.slice(1)}
        />
      ))}
  </div>
)

export default SocialMediaBar
